// export default (settings, module_name, index) => {
export default (settings, module_name) => {
  // const productData = document.querySelector('[data-content-container]').querySelector('[data-featured-product-data]').dataset;
  const contentContainer = document.querySelector('[data-content-container]');
  const contentHtml = contentContainer.querySelector('[data-featured-product-content]').innerHTML;

  const html = `
    <div class="Module-${module_name}__Content">
      ${contentHtml}
    </div>
    `;
  return html;
};
